export const UserRoleCssClasses = ["", "info", "warning", "primary", "success"];
export const UserRoleTitles = ["", "管理員", "群組管理員", "認證會員", "會員"];

export const UserGroupTitles = ["", "無", "水群"];
